module.exports = __webpack_public_path__ + "static/media/footer-logo.a52544e4.png";